export default "__VITE_ASSET__BuFziKe8__"